// @flow
import {
  post,
  RESTfulAPI,
  Resource,
} from '../lib/http';
import { API_BASE_URL, IS_API_IN_DEV_MODE } from '../settings';
import HTTPError from '../lib/HTTPError';

export const api = new RESTfulAPI(API_BASE_URL, 'api/v1', IS_API_IN_DEV_MODE);// process.env.NODE_ENV !== 'production');

export const login = (username: string, password: string) => post({
  url: api.getURL('web-token-auth'),
  data: { username, password },
  headers: { 'Content-Type': 'application/json' },
}).catch((error) => {
  const { isPlain, statusCode } = error;

  if (isPlain) {
    throw new HTTPError({
      statusCode,
      data: 'Error del servidor',
    });
  }

  throw error;
});

export const Omnisearch = new Resource({
  name: 'omnisearch',
  api,
  customization: {
    search: {
      method: 'GET',
      urlPart: 'search',
      isDetail: false,
    },
  },
});

export const Users = new Resource({
  name: 'users',
  api,
  customization: {
    groups: {
      method: 'GET',
      urlPart: 'groups',
      isDetail: true,
    },
    configurations: {
      method: 'GET',
      urlPart: 'configurations',
      isDetail: true,
    },
    emergencyPhones: {
      method: 'GET',
      urlPart: 'emergency-phones',
      isDetail: true,
    },
    parentProfile: {
      method: 'GET',
      urlPart: 'parent-profile',
      isDetail: true,
    },
    notifications: {
      method: 'GET',
      urlPart: 'notifications',
      isDetail: true,
    },
    notificationCount: {
      method: 'GET',
      urlPart: 'notifications-count',
      isDetail: true,
    },
    notificationReadAll: {
      method: 'GET',
      urlPart: 'notification-read-all',
      isDetail: true,
    },
    notificationSearch: {
      method: 'GET',
      urlPart: 'notification-search',
      isDetail: false,
    },
    getCode: {
      method: 'GET',
      urlPart: 'gen-login-token',
      isDetail: true,
    },
    trips: {
      method: 'GET',
      urlPart: 'trips',
      isDetail: true,
    },
    profilePicture: {
      method: 'POST',
      urlPart: 'set-profile-picture',
      isDetail: true,
    }
  },
});

export const Profiles = new Resource({
  name: 'profiles',
  api,
  customization: {
    search: {
      method: 'GET',
      urlPart: 'search',
      isDetail: false,
    },
  },
});

export const Notifications = new Resource({
  name: 'notifications',
  api,
});

export const OmniSearch = new Resource({
  name: 'omnisearch',
  api,
  customization: {
    search: {
      method: 'GET',
      urlPart: 'search',
      isDetail: false,
    },
  },
});

export const UserConfigurationTypes = new Resource({
  name: 'user-configuration-types',
  api,
});

export const UserConfigurations = new Resource({
  name: 'user-configurations',
  api,
});

export const Students = new Resource({
  name: 'students',
  api,
  customization: {
    nextRoutes: {
      method: 'GET',
      urlPart: 'next-routes',
      isDetail: true,
    },
    routeStopsSchedule: {
      method: 'GET',
      urlPart: 'route-stops-schedule',
      isDetail: true,
    },
    relatedRouteStops: {
      method: 'GET',
      urlPart: 'route-stops',
      isDetail: true,
    },
    relatedRoutes: {
      method: 'GET',
      urlPart: 'routes',
      isDetail: true,
    },
    updateRouteStopsSchedule: {
      method: 'PUT',
      urlPart: 'route-stops-schedule',
      isDetail: true,
    },
    gatewaysSchedule: {
      method: 'GET',
      urlPart: 'gateway-schedule',
      isDetail: true,
    },
    updateGatewaysSchedule: {
      method: 'PUT',
      urlPart: 'gateway-schedule',
      isDetail: true,
    },
    search: {
      method: 'GET',
      urlPart: 'search',
      isDetail: false,
    },
    parents: {
      method: 'GET',
      urlPart: 'parents',
      isDetail: true,
    },
    addParent: {
      method: 'POST',
      urlPart: 'add-parent',
      isDetail: true,
    },
    removeParent: {
      method: 'POST',
      urlPart: 'remove-parent',
      isDetail: true,
    },
    changeRequests: {
      method: 'GET',
      urlPart: 'change-requests',
      isDetail: true,
    },
  },
});

// TODO: remove in a moment
export const Parents = new Resource({
  name: 'parents',
  api,
  customization: {
    students: {
      method: 'GET',
      urlPart: 'students',
      isDetail: true,
    },
    addStudent: {
      method: 'POST',
      urlPart: 'add-student',
      isDetail: true,
    },
    routes: {
      method: 'GET',
      urlPart: 'routes',
      isDetail: true,
    },
    trips: {
      method: 'GET',
      urlPart: 'trips',
      isDetail: true,
    },
  },
});

export const Monitors = new Resource({
  name: 'monitors',
  api,
  customization: {
    nextRoute: {
      method: 'GET',
      urlPart: 'next-route',
      isDetail: true,
    },
    currentTrip: {
      method: 'GET',
      urlPart: 'current-trip',
      isDetail: true,
    },
    routes: {
      method: 'GET',
      urlPart: 'routes',
      isDetail: true,
    },
    dayRoutes: {
      method: 'GET',
      urlPart: 'day-routes',
      isDetail: true,
    },
    addRoute: {
      method: 'POST',
      urlPart: 'add-route',
      isDetail: true,
    },
  },
});

export const Buses = new Resource({
  name: 'buses',
  api,
  customization: {
    search: {
      method: 'GET',
      urlPart: 'search',
      isDetail: false,
    },
  },
});

export const Reports = new Resource({
  name: 'reports',
  api,
  customization: {
    trips_entry_exits: {
      method: 'GET',
      urlPart: 'trips-entry-exits',
      isDetail: false,
    },
    route_assitance: {
      method: 'GET',
      urlPart: 'route-asistance',
      isDetail: false,
    },
    trip_stops_completion_time: {
      method: 'GET',
      urlPart: 'trip-stop-completions',
      isDetail: false,
    },
    student_list_per_route: {
      method: 'GET',
      urlPart: 'trips-by-student',
      isDetail: false,
    },
  },
});


export const Routes = new Resource({
  name: 'routes',
  api,
  customization: {
    stops: {
      method: 'GET',
      urlPart: 'route-stops',
      isDetail: true,
    },
    createTrip: {
      method: 'GET',
      urlPart: 'create-trip',
      isDetail: true,
    },
    sortStop: {
      method: 'PATCH',
      urlPart: 'sort-stop',
      isDetail: true,
    },
    updateSchedule: {
      method: 'PATCH',
      urlPart: 'update-schedule',
      isDetail: true,
    },
    updateRouteType: {
      method: 'PATCH',
      urlPart: 'update-route-type',
      isDetail: true,
    },
  },
});

export const RouteStops = new Resource({
  name: 'route-stops',
  api,
  customization: {
    students: {
      method: 'GET',
      urlPart: 'students',
      isDetail: true,
    },
    addStudent: {
      method: 'POST',
      urlPart: 'add-student',
      isDetail: true,
    },
    removeStudent: {
      method: 'POST',
      urlPart: 'remove-student',
      isDetail: true,
    },
  },
});

export const Trips = new Resource({
  name: 'trips',
  api,
  customization: {
    students: {
      method: 'GET',
      urlPart: 'students',
      isDetail: true,
    },
    stops: {
      method: 'GET',
      urlPart: 'stops',
      isDetail: true,
    },
    saveAssistance: {
      method: 'POST',
      urlPart: 'take-assistance',
      isDetail: true,
    },
    getRoomToken: {
      method: 'POST',
      urlPart: 'get-room-token',
      isDetail: true,
    },
    completeTrip: {
      method: 'PATCH',
      urlPart: 'complete-trip',
      isDetail: true,
    }
  },
});

export const TripStops = new Resource({
  name: 'trip-stops',
  api,
});

export const School = new Resource({
  name: 'schools',
  api,
  customization: {
    trips: {
      method: 'GET',
      urlPart: 'trips',
      isDetail: true,
    },
    changeStopRequests: {
      method: 'GET',
      urlPart: 'change-stop-requests',
      isDetail: true,
    },
    changeStopRequestsCounter: {
      method: 'GET',
      urlPart: 'change-stop-requests-count',
      isDetail: true,
    },
    gateways: {
      method: 'GET',
      urlPart: 'gateways',
      isDetail: true,
    },
    buses: {
      method: 'GET',
      urlPart: 'buses',
      isDetail: true,
    },
    gates: {
      method: 'GET',
      urlPart: 'gates',
      isDetail: true,
    },
    users: {
      method: 'GET',
      urlPart: 'users',
      isDetail: true,
    },
    getRoomToken: {
      method: 'POST',
      urlPart: 'get-room-token',
      isDetail: true,
    },
  },
});

export const Devices = new Resource({
  name: 'devices',
  api,
});

export const Drivers = new Resource({
  name: 'drivers',
  api,
});

export const Gateways = new Resource({
  name: 'gateways',
  api,
  customization: {
    users: {
      method: 'GET',
      urlPart: 'users',
      isDetail: true,
    },
    addUser: {
      method: 'POST',
      urlPart: 'add-user',
      isDetail: true,
    },
    removeUser: {
      method: 'POST',
      urlPart: 'remove-user',
      isDetail: true,
    },
    addAction: {
      method: 'POST',
      urlPart: 'add-action',
      isDetail: true,
    },
    removeAction: {
      method: 'DELETE',
      urlPart: 'remove-action',
      isDetail: true,
    },
    search: {
      method: 'GET',
      urlPart: 'search',
      isDetail: false,
    },
  },
});

export const Gates = new Resource({
  name: 'gates',
  api,
  customization: {
    search: {
      method: 'GET',
      urlPart: 'search',
      isDetail: false,
    },
  },
});

export const ChangeStopRequest = new Resource({
  name: 'change-request',
  api,
  customization: {
    updateState: {
      method: 'PUT',
      urlPart: 'update-state',
      isDetail: true,
    },
  },
});

// export const Geocoding = new Resource({
//   name: 'geocoding/v5',
//   api: mapboxAPI,
//   customization: {
//     places: {
//       method: 'GET',
//       urlPart: 'mapbox.places/{filter}.json',
//       isDetail: false
//     }
//   }
// });

// export const MapboxApiURL =



// WEBPACK FOOTER //
// ./src/scripts/api/index.js